export default "__VITE_ASSET__DPQVAjhW__";